
  import { MODAL_LIST_DATA } from '@/constants/modals';

  export default {
    data () {
      return {
        email: ''
      };
    },
    computed: {},
    methods: {
      clickHandler () {
        this.$store.commit('modal/PUSH_MODAL', { id: MODAL_LIST_DATA.NEWSLETTER_SIGNUP });
      }
    }
  };
